import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

const Spinner = styled.div<{
  primaryColor: string
  secondaryColor: string
}>(
  ({ primaryColor, secondaryColor }) => css`
    width: 50px;
    height: 50px;
    border: 10px solid ${secondaryColor};
    border-top: 10px solid ${primaryColor};
    border-radius: 50%;
    animation: spinner 1.5s linear infinite;

    @keyframes spinner {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `
)

interface ILoaderWrapperProps {
  children: ReactNode
  isLoading: boolean
  primaryColor: string
  secondaryColor: string
}

export const LoaderWrapper = ({
  children,
  isLoading,
  primaryColor,
  secondaryColor,
}: ILoaderWrapperProps) => {
  return isLoading ? (
    <Spinner
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
    />
  ) : (
    <>{children}</>
  )
}
